import { ErrorMessage, LoadingPlaceholder } from 'components';
import { observer } from 'mobx-react-lite';

const withInitialization =
  (...useHooks) =>
  (Component) => {
    const InitializationComponent = (props) => {
      const items = useHooks.map((u) => u());
      const isInitialized = !items.find(({ isInitialized }) => !isInitialized);
      const error = items.find(({ error }) => error)?.error;

      return isInitialized ? (
        error ? (
          <ErrorMessage description={error} />
        ) : (
          <Component {...props} />
        )
      ) : (
        <LoadingPlaceholder />
      );
    };

    return observer(InitializationComponent);
  };

export default withInitialization;
